<template>
  <div v-if="content" v-editable="content" class="textBloc">
    <div class="text" :style="`text-align:${content.align};`">
      <vue-markdown class="markdown" :style="`line-height:${content.interligne};`">{{content.text}}</vue-markdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.textBloc {
  width: $content-width;
  margin: auto;
  max-width: $max-width;
  padding: 1em 0;
  .markdown {
    white-space: pre-wrap;
    strong {
      font-weight:bold;
    }
  }
}
</style>
